import { render, staticRenderFns } from "./bmsBlockPicker.vue?vue&type=template&id=567df4f8&scoped=true&"
import script from "./bmsBlockPicker.vue?vue&type=script&lang=js&"
export * from "./bmsBlockPicker.vue?vue&type=script&lang=js&"
import style0 from "./bmsBlockPicker.vue?vue&type=style&index=0&id=567df4f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567df4f8",
  null
  
)

export default component.exports